import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import * as formatter from 'mt-react-common/utils/formatter';

// eslint-disable-next-line react/prefer-stateless-function
class RatingPointHistoryItem extends Component {
  render() {
    return (
      <tr>
        <td>{formatter.dateFormat3(this.props.pointItem.createdAt)}</td>
        <td className="text-center">
          {this.props.pointItem.points > 0 ? (
            <span className="text-success">
              <i className="fa fa-plus-circle" />
            </span>
          ) : (
            <span className="text-danger">
              <i className="fa fa-minus-circle" />
            </span>
          )}
        </td>
        <td>{this.props.pointItem.pointsTypeTitle}</td>
        <td>
          <span className="text-muted">{this.props.pointItem.comment}</span>
        </td>
        <td className="text-right">
          <span
            className={
              this.props.pointItem.points > 0 ? 'text-success' : 'text-danger'
            }
          >
            {this.props.pointItem.points > 0 ? '+' : ''}
            {this.props.pointItem.points}
          </span>
        </td>
      </tr>
    );
  }
}

RatingPointHistoryItem.propTypes = {
  pointItem: PropTypes.shape({
    id: PropTypes.number.isRequired,
    points: PropTypes.number.isRequired,
    pointsTypeTitle: PropTypes.string.isRequired,
    comment: PropTypes.string.isRequired,
    createdAt: PropTypes.string.isRequired
  }).isRequired
};

export default withRouter(RatingPointHistoryItem);



// WEBPACK FOOTER //
// ./src/components/Rating/RatingPointHistoryTable/RatingPointHistoryItem.js